/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Injectable } from "@angular/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { Logger } from "../../../core/libs/logger";

@Injectable({
   providedIn: "root"
})
export class AjaxBusyService {
   private isAjaxBusy: boolean;
   // use 1 events only for output to avoid fire same status multiple times.
   private ajaxBusySubject$: BehaviorSubject<boolean>;

   constructor() {
      this.isAjaxBusy = false;
      this.ajaxBusySubject$ = new BehaviorSubject<boolean>(this.isAjaxBusy);
   }

   public setAjaxBusy = (isBusy: boolean) => {
      if (isBusy !== this.isAjaxBusy) {
         this.isAjaxBusy = isBusy;
         Logger.debug("ajaxBusy status changed to: " + isBusy);
         this.ajaxBusySubject$.next(this.isAjaxBusy);
      }
   };

   public getAjaxBusy = (): boolean => {
      return this.isAjaxBusy;
   };

   public subscribe = (callback: (boolean) => void): Subscription => {
      return this.ajaxBusySubject$.subscribe({
         next: callback
      });
   };
}
